<template>
	<div class="userpage" :class="$store.state.mode">
		<div class="navbar" :class="($store.state.mode === 'dark') ? 'darkModeActive' : 'false'">
			<i  v-on:click="$router.go(-1)" class="material-icons">arrow_back</i>
			<div class="title">
				My Profile
			</div>
			<div v-on:click="logout">
				<i class="material-icons">logout</i>
			</div>
		</div>
		<div class="profile--wrapper">
			<div class="profile">
				<img
				class="image-profile"
				:class="($store.state.mode === 'dark') ? 'image-profile--dark' : 'false'"
				:src="$store.state.currentUser.photoURL"
				:alt="$store.state.currentUser.displayName + ', ' + $store.state.currentUser.email"
				>
				<div class="details">
					<a class="name">
						{{ $store.state.currentUser.displayName }}
					</a>
					<a class="bio" :class="($store.state.mode === 'dark') ? 'darkModeActive' : 'false'" >
						{{ $store.state.currentUser.email }}
					</a>
				</div>
				<div class="logout--wrapper">
					<div v-on:click="share()" class="btn--wrapper">
						<div class="title">
							<i class="material-icons">share</i>
							Share app
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="audioPlaylist.length > 0" class="heading">
			<div class="title">Recently Played</div>
			<div class="subtitle">from all creator and audio</div>
		</div>
		<div v-for="(item, index) in audioPlaylist" :key="index" :class="{'active' : $store.state.isPlaying == item.audio}" class="audio-list--wrapper">
			<div class="image--wrapper">
				<div
					@click="$router.push({ name: 'ProfileCreator', params: { id: item.uid }})"
					:style="{ backgroundImage: `linear-gradient(rgba(255,255,255, 0), rgba(0, 0, 0, .5)), url(${item.cover})` }"
					class="image-profile" :alt="item.creator + ', ' + item.title">
				</div>
			</div>
			<div class="content--wrapper">
				<div class="creator--wrapper">
					<div class="name">{{ item.creator }}</div>
					<div class="verified--wrapper">
						<img v-if="item.verified" src="@/assets/icons/verified.png" class="verify" :alt="item.creator">
					</div>
				</div>
				<div @click="play(item.audio)" class="audioTitle">{{ item.title }}</div>
				<div class="date" :class="($store.state.mode === 'dark') ? 'dark-date' : 'false'">{{ humanDate(item.created_at.toDate()).fromNow() }}
					<div :class="{'active' : $store.state.isPlaying == item.audio}" class="dot"></div> {{ timeConvert(item.duration) }} min
				</div>
			</div>
			<div class="play--wrapper" v-ripple v-if="$store.state.isStoping == item.audio" @click="play(item.audio)">
				<i class="material-icons">play_circle_outline</i>
			</div>
			<div class="play--wrapper" v-ripple v-else-if="$store.state.isPlaying == item.audio" @click="pause(item.audio)">
				<i class="material-icons">pause_circle_outline</i>
			</div>
			<div class="play--wrapper" v-ripple v-else @click="play(item.audio)">
				<i class="material-icons">play_circle_outline</i>
			</div>
		</div>
	</div>
</template>

<script>
import firebase from 'firebase'
import db from '@/db'
export default {
	data() {
		return {
			audioPlaylist: [],
		}
	},
	methods: {
		share: function() {
			location.href = 'https://api.whatsapp.com/send?text=' + encodeURIComponent('JiTube - an Islamic audio and podcasts.' + '') + 'https://jitube.web.app'
		},
		play: function(audioUrl) {
			this.$store.commit('playSound', audioUrl)
		},
		pause: function(audioUrl) {
			this.$store.commit('pauseSound', audioUrl)
		},
		logout: function() {
			let _this = this
			firebase.auth().signOut().then(function() {
				_this.$store.commit('setCurrentUser',null)
				setTimeout(() => _this.isHidden = false, 1000);
				_this.$router.push('/landing')
			}).catch(function(error) {
				_this.console.log(error)
			});
		},
	},
	mounted() {
		let _this = this
		db.collection('recentPlay').where('uid','==',this.$store.state.currentUser.uid).orderBy('created_at','desc').onSnapshot((recents) => {
			_this.audioPlaylist = []
			recents.forEach((recent) => {
				db.collection('episodes').doc(recent.data().eid).get().then((episode) => {
					db.collection('creator').doc(episode.data().uid).get().then((creator) => {
						_this.audioPlaylist.push({
							audio: episode.data().audio,
							created_at: episode.data().created_at,
							duration: episode.data().duration,
							title: episode.data().title,
							listener: episode.data().listener,
							uid: episode.data().uid,
							creator: creator.data().podcastName,
							cover: creator.data().cover,
							verified: creator.data().verified,
						})
					})
				})
			})
		})
	},
};
</script>

<style lang="scss" scoped>
$base-color: #1b7b46;
$inner-color: #caefe2;
$accent-color: #2fca74;
.heading {
	margin: 2rem 1.5rem 1.5rem;
	.title {
		font-size: 18px;
		font-weight:bold;
		letter-spacing: -.5px;
	}
	.subtitle {
		opacity: .5;
		font-size: 12px;
		text-transform: lowercase;
	}
}
.userpage {
	position: absolute;
	width: 100%;
	padding-bottom: 3.4rem;
	background: #fff;
	color: #000;
}
/* DARK MODE */
.dark {
	background: #000;
	color: #fff;
}
/* HEADER */
.navbar.false {
	background-image: linear-gradient(rgb(255,255,255), rgb(255,255,255));
	box-shadow: 0 1px 10px rgba(0,0,0, .03);
}
.navbar {
	z-index: 99;
	position: fixed;
	width: 100%;
	height: 4rem;
	padding: 0 1.5rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	backdrop-filter: blur(1px);
	background-image: linear-gradient(rgb(0,0,0), transparent);
	.title {
		font-size: 14px;
	}
}
.profile--wrapper {
	padding: 5rem 1.5rem 2rem;
	border-bottom: 1px solid rgba(255,255,255, .1);
	.profile {
		display: flex;
		flex-direction: column;
		align-items: center;
		.image-profile {
			width: 150px;
			height: 150px;
			border-radius: 50%;
			background-size: cover;
			background-position: center;
		}
		.details {
			width: 100%;
			padding: 1rem 0;
			display: flex;
			flex-direction: column;
			align-items: center;
			text-align: center;
			.name {
				display: flex;
				font-size: 24px;
				letter-spacing: -.5px;
				font-weight: bold;
			}
			.bio {
				padding: .2rem 0;
				font-size: 12px;
				opacity: .5;
				letter-spacing: .2px;
			}
		}
		.logout--wrapper {
			width: 100%;
			padding: 0 4rem;
			display: flex;
			justify-content: space-around;
			align-items: center;
			.btn--wrapper {
				z-index: 98;
				display: flex;
				border-radius: 12px;
				font-size: 12px;
				padding: .75rem 1rem;
				transition: .25s ease-in-out;
				color: $accent-color;
				background-color: rgba($base-color, .10);
				&.isActive {
					color: $base-color;
					border: 1px solid rgba(27, 123, 70, 0.25);
					background-color: transparent;
				}
				.title {
					display: flex;
					justify-content: center;
					align-items: center;
					i {
						margin-right: .5rem;
						font-size: 14px;
					}
				}
			}
		}
	}
}
</style>